module.exports = __webpack_public_path__ + "static/login-bg-be2e9a02a773eac061cd01d2724c9825.jpg";